<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height column  ma-0 pt-0 >
        
        <scroll-area>

          <template slot="header">

            <v-toolbar class="active" :height="44" flat dark>
              <v-toolbar-title>
                <span class="body-2 uppercase blacktext--text">{{ $t('VINTEO') }}</span>
              </v-toolbar-title>

              <v-layout fill-height justify-end align-center>

                <v-tooltip v-if="edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                  :data-testid="$options.name + '__btn__' + 'submit'"
                  @click="() => submit()">
                    <svg-icon
                      :color="'blacktext'"
                      :name="'done'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('save') }}</span>
                </v-tooltip>

                <v-tooltip v-if="!edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                  :data-testid="$options.name + '__btn__' + 'edit'"
                  @click="() => {edit = !edit}">
                    <svg-icon
                      :color="'blacktext'"
                      :name="'edit'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('edit') }}</span>
                </v-tooltip>

                <v-tooltip v-if="edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator"  
                  :data-testid="$options.name + '__btn__' + 'cancelEdit'"
                  @click="() => cancelEdit()">
                    <svg-icon
                      :color="'blacktext'"
                      :name="'close'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('cancel') }}</span>
                </v-tooltip>

              </v-layout>

            </v-toolbar>

          </template>
          
          <template slot="body">

            <v-layout fill-height justify-start ma-0 pa-1 >

              <v-layout column fill-height justify-start ma-0 >

                <v-layout v-for="(field, name) in getFields" :key= " 'common' + name" shrink pa-0 ma-0>

                  <v-layout v-if="field.show == 'true' && (field.type == 'text' || field.type == 'integer')"   pb-1>
                    <v-flex xs6  pa-0>
                      <v-text-field 
                        :value="$t(field.name)"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                 
                      <v-text-field
                        v-if="field.name != 'password'"
                        :data-testid="$options.name + '__text-field__' + field.name"
                        v-model="model.obj[field.name]"
                        :type="field.hide_pass ? 'password' : 'text'"
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        :required="model.fields[field.name].required"
                        validate-on-blur
                        light
                        outline
                        flat
                        :readonly="!edit"
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>

                      <v-text-field
                        v-if="field.name == 'password'"
                        :data-testid="$options.name + '__text-field__' + field.name"
                        v-model="model.obj[field.name]"
                        :type="visible ? 'text' : 'password'"
                        @click:append="() => (visible = !visible)"
                        :append-icon="visible ? 'visibility' : 'visibility_off'"
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        :required="model.fields[field.name].required"
                        validate-on-blur
                        light
                        outline
                        flat
                        :readonly="!edit"
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="field.show == 'true' && field.type == 'boolean'"  shrink pa-0>
                    
                    <v-checkbox
                      :readonly="!edit"
                      small
                      light
                      color="secondary"
                      :data-testid="$options.name + '__checkbox__' + field.name"
                      v-model="model.obj[field.name]"
                    >
                      <template v-slot:label>
                        <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                        <span class="black--text" v-else>{{$t(field.name)}}</span>
                      </template>
                    </v-checkbox>

                  </v-layout>

                  <v-layout v-if="field.show == 'true' && (field.type == 'select' || field.type == 'select_enum')"  pa-0>

                    <v-flex xs6  pa-0>
                            
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="white"
                      >

                      </v-text-field>

                    </v-flex>

                    <v-flex xs12  px-0 pa-0>

                      <v-select
                        :data-testid="$options.name + '__select__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        :items="getItems[field.cls]"
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        :readonly="!edit"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable
                      >
                        <template v-slot:item="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                      </v-select>

                    </v-flex>

                  </v-layout>
                </v-layout>

              </v-layout>
              
            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface ModelData {
  obj: Record<string, any>
  fields: Record<string, any>
  items?: Record<string, any>
}

interface MetaData {
  [key: string]: any
}

interface RestApiData {
  $id?: string
  _cmdb_?: boolean
  [key: string]: any
}

export default Vue.extend({
  name: 'VINTEO',

  components: {
    scrollArea,
    scrollTable,
    svgIcon,
  },

  props: {},

  data(): {
    meta: MetaData | null
    data: RestApiData | null
    edit: boolean
    model: ModelData
    visible: boolean
  } {
    return {
      meta: null,
      data: null,
      edit: false,
      model: {
        obj: {},
        fields: {}
      },
      visible: false,
    }
  },

  computed: {
    getData(): RestApiData | null {
      return this.data
    },

    getObj(): Record<string, any> {
      return this.model.obj
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getItems(): Record<string, any> | undefined {
      return this.model.items
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadMeta()
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        this.meta = await this.$loadMeta('rest_api')
        const objects = await this.$bridge.getObjectsByClass('rest_api')
        this.data = objects?.[0] || null
        console.log(this.$options.name, 'loadMeta', 'caller', caller, 'this.meta', this.meta)

        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          if (this.getData) {
            await this.prepareData()
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'loadMeta smth wrong', error)
      }
    },

    async prepareData(): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta)
        console.log(this.$options.name, 'prepareData', 'model', model)
        this.model = model

        if (this.getData?.$id) {
          this.$set(this.model.fields, '$id', this.getData.$id)
        }
      } catch (error) {
        this.setLoader('prepareData', false)
        console.error('CATCH', 'VINTEO', 'prepareData', 'SMTH WRONG', error)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    async cancelEdit(): Promise<void> {
      this.edit = false
      await this.setup()
    },

    async submit(): Promise<void> {
      console.log(this.$options.name, 'submit', 'START')
      try {
        if (!this.data) return
        this.setLoader('submit', true)

        const obj = this.data._cmdb_ ? this.data : new CCMDBObject({ ...this.data })
        const u = await obj.update(this.model.obj)
        console.log(this.$options.name, 'submit', 'updated', u)

        this.setLoader('submit', false)
        this.$dialog.notify.success('Параметры успешно обновлены', { timeout: 5000 })
        this.edit = false
        await this.setup()
      } catch (error) {
        console.error(this.$options.name, 'submit smth wrong', error)
        this.setLoader('submit', false)
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
